export default __webpack_public_path__ + "static/kings-league-b90b1d5cf55d163c60d36e16c821c40c.png";